import { h, Component } from 'preact';

import { joinClasses } from 'utils/utils';

import Sound from 'components/bolt/sound/sound';
import SharePopout from 'components/bolt/header/sharePopout';
import Store from 'store/store';
import 'store/main';

import s from './header.sss';

export default class Header extends Component {
	constructor(props) {
		super(props);

		this.showSkip = this.showSkip.bind(this);
		this.hideSkip = this.hideSkip.bind(this);
		this.skip = this.skip.bind(this);
		this.share = this.share.bind(this);
		this.toggleShare = this.toggleShare.bind(this);

		this.state = {
			showSkip: false,
			showHeadphones: true
		};

		Store.on('PORTAL_ANIMATION_STARTED', this.showSkip);
		Store.on('PORTAL_ANIMATION_ENDED', this.hideSkip);
		Store.on('SHARE', this.share);
		this.pagePaths = {
			holdingSliceOfLife: '1',
			holdingSciFi: '2',
			holdingPop: '3',
			sliceOfLife: '1/home',
			sciFi: '2/home',
			pop: '3/home'
		};
	}

	componentWillUnmount() {
		Store.off('PORTAL_ANIMATION_STARTED', this.showSkip);
		Store.off('PORTAL_ANIMATION_ENDED', this.hideSkip);
		Store.off('SHARE', this.share);
	}

	showSkip() {
		this.setState({ showSkip: true, showHeadphones: false });
	}

	hideSkip() {
		this.setState({ showSkip: false });
	}

	skip() {
		this.hideSkip();
		Store.emit('SKIP_PORTAL');
	}

	getShareUrl() {
		const baseUrl = this.props.appData?.meta?.url;
		const activePage = this.props.activePage;
		if (activePage === 'portals') {
			return baseUrl + (baseUrl.endsWith('/') ? '' : '/');
		}
		return baseUrl + (baseUrl.endsWith('/') ? '' : '/') + this.pagePaths[activePage] + '/';
	}

	share() {
		const url = this.getShareUrl();
		const shareCopy = this.props.appData?.copy?.baseCopy?.$SOCIAL_COPY || 'Check out this cool Anime site';

		if (navigator.share && !this.props.client?.isDesktopSize) {
			navigator.share({ url, text: shareCopy });
		} else {
			this.toggleShare();
		}
	}

	toggleShare() {
		this.setState({ shareOpen: !this.state.shareOpen });
	}

	render(props, state) {
		const { showSkip, shareOpen, showHeadphones } = state;
		const imageRoot = props?.appData?.urls.roots.image;
		const copy = props?.appData?.copy.baseCopy;
		const logoSrc = imageRoot + '/netflix-logo.svg';
		const logoAlt = copy.$NETFLIX_LOGO_ALT || 'Netflix logo';
		const shareAria = copy.$SHARE_ARIA_LABEL || 'Share Open Anime on social media';
		const soundAria = copy.$SOUND_ARIA_LABEL || 'Toggle sound';
		const skipAria = copy.$SKIP_ARIA_LABEL || 'Skip introduction video';
		const headphonesCopy = copy.$HEADPHONES_PROMPT || 'Use headphones for the best experience!';

		const headerData = {};
		const hideForAR = this.props.activePage.endsWith('AR');
		const shouldHideShareForHoldingPage = this.props?.activePage?.match(/holding/) && !this.props?.headerData?.holdingPageLoaded;
		const shareUrl = this.getShareUrl();

		return (
			<header class={joinClasses(s.wrapper, hideForAR && s.hideForAR)}>
				<img class={s.logo} src={logoSrc} alt={logoAlt} />
				<div class={joinClasses(s.headphones, showHeadphones && s.show)}>
					<div class={s.headphonesIcon} />
					<div class={s.headphonesCopy}>{headphonesCopy}</div>
				</div>
				<div class={s.buttons}>
					<Sound
						ariaLabel={soundAria}
						wrapperClass={joinClasses(s.button, s.sound)}
						appData={props.appData}
						pageId={props.activePage}
					/>
					<button ariaLabel={shareAria} class={joinClasses(s.button, s.share, shouldHideShareForHoldingPage && s.hide)} onClick={this.share} />
					<button ariaLabel={skipAria} class={joinClasses(s.skip, showSkip && s.show)} onClick={this.skip} />
					<SharePopout
						appData={props.appData}
						shareOpen={shareOpen}
						toggleSharePop={this.toggleShare}
						shareDetails={headerData.shareDetails}
						shareUrl={shareUrl}
						key="share"
						pageId={this.props.activePage}
						copy={copy}
					/>
				</div>
			</header>
		);
	}
}
